import {utils} from './utils'

const BootstrapTweaks = () => {

  const handleModals = (freezeScrollOnOpen = false) => {

    const modals = document.querySelectorAll('.modal')
    const offcanvasElements = document.querySelectorAll('.offcanvas')
    const offcanvasBgElements = document.querySelectorAll('.offcanvas-backdrop')

    modals.forEach(modal => {
      document.body.appendChild(modal)

      if(freezeScrollOnOpen){
        modal.addEventListener('hide.bs.modal', function () {
          utils.enableScroll()
        })
        modal.addEventListener('show.bs.modal', function () {
          utils.disableScroll()
        })
      }
    })

    offcanvasElements.forEach(offcanvas => {
      document.body.appendChild(offcanvas)
    })

    offcanvasBgElements.forEach(offcanvas => {
      document.body.appendChild(offcanvas)
    })
  }

  const addFloatingLabelsToForms = (jQuery) => {
    jQuery(document).on('gform_post_render', function(){

      // This logic can be modified to enable floating labels or commented out
      // as-is this will change email fields to floating label fields but nothing else
      if(document.querySelectorAll('.gfield').length > 0) {
          document.querySelectorAll('.gfield').forEach(field => {
              if(field.querySelector('.ginput_container_email')){
                  var target = field.querySelector('.ginput_container_email') // grab div containing input
                  target.classList.add('form-floating') // add class to outer div
                  target.appendChild(field.querySelector('label')) // label must be sibling after the input
                  // a placeholder is required (though not visible), because placeholder:shown selector is used for CSS
                  target.querySelector('input').setAttribute('placeholder', 'youremail@example.com')
              }
          })
      } 
    })
  }

  return {
    handleModals,
    addFloatingLabelsToForms
  }

}

export const bootstrapTweaks = BootstrapTweaks()